module.exports = __webpack_public_path__ + "img/chanquansousuohoutai.bf13941e.png";